export const UCCPlumbingFee = [
  {
    label: 'General Fees',
    data: {
      WaterCloset: 0,
      UrinalBidet: 0,
      Bathtub: 0,
      Lavatory: 0,
      Shower: 0,
      FloorDrain: 0,
      Sink: 0,
      Dishwasher: 0,
      DrinkFountain: 0,
      WashingMachine: 0,
      HoseBib: 0
    }
  },
  {
    label: 'Piping Fees',
    data: {
      GasPiping: 0,
      FuelOilPiping: 0,
      SteamBoiler: 0,
      HotWaterBoiler: 0,
      WaterHeater: 0
    }
  },
  {
    label: 'Sewer Pumps Fees',
    data: {
      SewerPumpsCommercial: 0,
      SewerPumpsResidentialSingle: 0,
      SewerPumpsResidentialMultifixture: 0
    }
  },
  {
    label: 'Water Cooled Fees',
    data: {
      RefrigeratorUnit: 0,
      ResidentialAC: 0,
      CommercialAC: 0
    }
  },
  {
    label: 'Interceptor Fees',
    data: {
      InterceptorInterior: 0,
      InterceptorExterior: 0
    }
  },
  {
    label: 'Backflow Fees',
    data: {
      CommercialBackflow: 0
    }
  },
  {
    label: 'Demolition Fees',
    data: {
      DemolitionFee: 0,
      LPGTankInstallation: 0,
      AnnualRecertificationFee: 0
    }
  },
  {
    label: 'Other Fees',
    data: {
      SewerConnection: 0,
      WaterService: 0,
      ActiveSolarSystem: 0,
      VentsStacks: 0,
      LawnSprinklerSystem: 0,
      WaterFilterCondSystem: 0,
      SumpPump: 0,
      RoofDrains: 0,
      CondensateDrain: 0,
      MedicalGasSystem: 0,
      PressureBooster: 0,
      PoolHeater: 0,
      CommercialRTU: 0,
      PoolPiping: 0,
      CommercialHVACHydronicPiping: 0,
      ResidentialHVACHydronicPiping: 0,
      CommercialRoofDrainLeaders: 0,
      NewFurnaceInstall: 0,
      ResidentialBackflow: 0,
      MinimumFee: 0,
    }
  }
];

export const UCCElectricalFee = [
  {
    label: 'Receptacles and fixtures',
    data: {
      First25ReceptaclesFixtures: 0,
      EachAdditional25Receptacles: 0,
      EachAdditional25Over150Receptacles: 0
    }
  },
  {
    label: 'Motors and electrical devices',
    data: {
      MotorsUpTo10Hp: 0,
      MotorsUpTo50Hp: 0,
      MotorsUpTo100Hp: 0,
      LargeMotorsDevicesFee: 0
    }
  },
  {
    label: 'Transformers and generators',
    data: {
      TransformersUpTo10Kw: 0,
      TransformersUpTo45Kw: 0,
      TransformersUpTo1215Kw: 0,
      LargeTransformersGeneratorsFee: 0
    }
  },
  {
    label: 'Service panels, entrances and sub-panels',
    data: {
      ServicePanel100Amps: 0,
      ServicePanel200Amps: 0,
      ServicePanel400Amps: 0,
      ServicePanelAbove400Amps: 0
    }
  },
  {
    label: 'Photovoltaic systems',
    data: {
      PhotovoltaicSystem1To50Kw: 0,
      PhotovoltaicSystem51To100Kw: 0,
      PhotovoltaicSystemAbove100Kw: 0
    }
  },
  {
    label: 'Pool Fees',
    data: {
      AnnualCommercialPoolInspection: 0,
      ResidentialPoolPermit: 0,
      ResidentialAbovegroundPool: 0
    }
  },
  {
    label: ' Car Charger Fees',
    data: {
      CarChargerBaseFee: 0,
      CarChargerAdditionalFee: 0
    }
  },
  {
    label: 'Other Fees',
    data: {
      AirConditionerOver1Hp: 0,
      ElectricalSigns: 0,
      MeterResetFee: 0
    }
  }
];

export const UCCFireProtectionFee = [
  {
    label: 'Sprinkler Heads Fees',
    data: {
      SprinklerHead1to20: 0,
      SprinklerHead21to100: 0,
      SprinklerHead101to200: 0,
      SprinklerHead201to400: 0,
      SprinklerHead401to1000: 0,
      SprinklerHeadOver1000: 0,
    }
  },
  {
    label: 'Smoke and Heat Detectors Fees',
    data: {
      SmokeDetector1to5: 0,
      SmokeDetector6to10: 0,
      SmokeDetector11to15: 0,
      SmokeDetector16to20: 0,
      SmokeDetector21to25: 0,
      SmokeDetector26to30: 0,
      SmokeDetectorOver30: 0,
    }
  },
  {
    label: 'Other Fire Alarm Devices Fees',
    data: {
      ManualPullStations: 0,
      AudibleDevices: 0,
      ControlPanel: 0,
      TamperAndSupervisorySwitches: 0,
      FireAlarmDeviceChanges: 0,
    }
  },
  {
    label: 'Pre-engineered Systems Fees',
    data: {
      CarbonDioxide: 0,
      FoamSuppression: 0,
      WetChemical: 0,
      CleanAgent: 0,
    }
  },
  {
    label: 'Standpipe Fees',
    data: {
      StandpipeRisers: 0,
    }
  },
  {
    label: 'Other Fire Protection Fees',
    data: {
      KitchenHoodExhaustSystems: 0,
      IncineratorsAndCrematoriums: 0,
      GasOrOilFiredAppliance: 0,
      SmokeControlSystems: 0,
      UndergroundFireMains: 0,
      FirePumpReviewAndFieldAccept: 0,
    }
  },
  {
    label: 'Tank Installation Fees',
    data: {
      FlammableLiquidTankUpTo275Gallons: 0,
      FlammableLiquidTank276To1000Gallons: 0,
      FlammableLiquidTank1001To2000Gallons: 0,
      FlammableLiquidTankOver2000Gallons: 0,
    }
  },
  {
    label: 'Removal or Abandonment of Tank Fees',
    data: {
      TankRemovalUpTo275Gallons: 0,
      TankRemoval276To1000Gallons: 0,
      TankRemovalOver1000Gallons: 0,
    }
  },
  {
    label: 'Photovoltaic Fire Fee',
    data: {
      PhotovoltaicForFire: 0,
    }
  },
  {
    label: 'Minimum Fee for Fire Subcode',
    data: {
      MinimumFee: 0,
    }
  }
];

export const UCCMechanicalFee = [
  {
    label: 'Sprinkler Heads Fees',
    data: {
      GasPiping: 0,
      FuelOilPiping: 0,
      SteamBoiler: 0,
      HotWaterBoiler: 0,
      WaterHeater: 0,
      Fireplaces: 0,
      LiquidPropaneGasTank: 0,
      Furnance: 0,
      FlammableLiquidTankUpTo275Gallons: 0,
      FlammableLiquidTank276To1000Gallons: 0,
      FlammableLiquidTank1001To2000Gallons: 0,
      FlammableLiquidTankOver2000Gallons: 0,
      Chimney: 0
    }
  }
];

export const UCCBuildingFee = [
  {
    label: 'VolumeFees',
    data: {
      ResidentialR3R5: 0,
      AssemblyInstitutionalA1A5R1R2I1I3: 0,
      //'BusinessEducationalFactoryMercantileUtilityBEF1F2MU': 0,
      'BEF1F2MU': 0,
      'S1S2Under100k': 0,
      'S1S2Over100k': 0,
    }
  },
  {
    label: 'MinimumFees',
    data: {
      'NewConstruction': 0,
      'Addition': 0,
      'RenovationResidential': 0,
      'RenovationCommercial': 0,
      'BuildingSubcode': 0,
    }
  },
  {
    label: 'Certificates',
    data: {
      'Occupancy': 0,
      'ContinuedOccupancy': 0,
      'ClearanceLead': 0,
      'Temporary': 0,
    }
  },
  {
    label: 'AdministrativeFees',
    data: {
      'PermitUpdate': 0,
      'VariationApplication': 0,
      'NonrefundableDeposit': 0,
      'PrototypeProcessingCredit': 0,
    }
  },
  {
    label: 'RenovationFees',
    data: {
      'Standard': 0,
      'S1S2First50k': 0,
      'S1S250kTo100k': 0,
      'S1S2Above100k': 0,
    }
  },
  {
    label: 'InstallationFees',
    data: {
      'SwimmingPoolInGround': 0,
      'SwimmingPoolAboveGround': 0,
      'PoolFence': 0,
      'WoodburningStove': 0,
      'MasonryFireplace': 0,
      'WindowsInstallation': 0,
      'TemporaryStructures': 0,
      'WoodenDeckUnder12': 0,
      'WoodenDeckOver12': 0,
      'SatelliteDish': 0,
      'RoofReplacementResidential': 0,
      'RoofReplacementWithPlywood': 0,
      'CommercialRoofReplacement': 0,
      'SidingInstallation': 0,
      'ThreeSeasonRooms': 0,
      'GeneratorResidential': 0,
      'SolarInstallationResidential': 0,
      'DemolitionResidential': 0,
      'DemolitionCommercial': 0,
      'WallSignPerSqFt': 0,
      'FreestandingSign': 0,
      'MinimumSignFee': 0,
      'ElevatorInstallation': 0,
      'AsbestosRemoval': 0,
      'LeadAbatement': 0,
      'ShedsUnder200SqFt': 0,
      'RetainingWallAbove550SqFtClass3': 0,
      'RetainingWallUnder550SqFtClass3': 0,
      'RetainingWallOtherStructurePerThousand': 0,

    }
  }
];
